<template>
    <div v-cloak class="form-info">
        <el-form :model="staffInfo" :rules="staffRules" ref="staffInfo" class="demo-ruleForm">
            <div class="form-row">
                <div class="form-label">
                    <label class="required">姓名</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="name">
                        <el-input v-model="staffInfo.name" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>员工编号</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="no">
                        <el-input :disabled="noDisabled" v-model="staffInfo.no" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div v-if="id == null " class="form-row">
                <div class="form-label">
                    <label class="required">用户手机</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="phoneNo">
                        <el-input v-model="staffInfo.phoneNo" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>联系电话</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="contactTel">
                        <el-input v-model="staffInfo.contactTel" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>联系邮箱</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="contactEmail">
                        <el-input v-model="staffInfo.contactEmail" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-row spacing">
                <div class="form-label">
                    <label>员工头像</label>
                </div>
                <div class="form-value">
                    <swb-file-upload :fileFor="'solution'" fileGroup="image-misc" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :updateFileUuid="staffInfo.headUuid" :onDone="onUploadDone"
                                     :multipleFile="true"></swb-file-upload>
                    <ul class="file-area clearfix" v-if="staffInfo.headUuid != null">
                        <li class="file-item show-usage image deletable">
                            <div class="file-content">
                                <img :src="staffInfo.fileBrowseUrl"/>
                                <div class="delete-icon" @click="removeUpload()"></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>描述</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="memo">
                        <el-input class="width-2x" type="textarea" :rows="2" placeholder="请输入内容" v-model="staffInfo.memo"></el-input>
                    </el-form-item>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Routes} from '../../app.vues'

    import realAuthxApi from '../../api/realAuthx'
    import servicerApi from '../../api/servicer'
    //
    export default {
        name: 'swb-servicer-xStaff-save',
        desc: '保存商户员工信息',
        props: {
            id: {
                type: Number,
                default: null
            },
            phoneNo: {
                type: String,
                default: null
            }
        },
        data: function () {
            let checkPhoneNo = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    return callback(new Error('用户手机不能为空'));
                } else {
                    if (!Utils.isMobileNo(value)) {
                        return callback(new Error('必须是手机号码'));
                    } else {
                        callback();
                    }
                }
            };
            let validateName = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请输入名称'));
                } else {
                    callback();
                }
            };
            let checkContactTel = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback();
                } else {
                    if (!Utils.isPhoneNo(value)) {
                        return callback(new Error('必须是手机号或座机号'));
                    } else {
                        callback();
                    }
                }

            };
            let checkContactEmail = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback();
                } else {
                    if (!Utils.isEmail(value)) {
                        return callback(new Error('请输入正确的邮箱地址'));
                    } else {
                        callback();
                    }
                }
            };
            let validateNo = function (rule, value, callback) {
                if (!Utils.isNoB(value)) {
                    if (value.length >= 15) {
                        callback(new Error("人员编号不可大于15个字符"))
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            //
            return {
                staffInfo: {},
                staffRules: {
                    phoneNo: [{
                        validator: checkPhoneNo,
                        trigger: 'blur'
                    }],
                    name: [{
                        validator: validateName,
                        trigger: 'blur'
                    }],
                    contactEmail: [{
                        validator: checkContactEmail,
                        trigger: 'blur'
                    }],
                    contactTel: [{
                        validator: checkContactTel,
                        trigger: 'blur'
                    }],
                    no: [{
                        validator: validateNo,
                        trigger: 'blur'
                    }]
                },
                noDisabled: false
            }
        },
        created: function () {
            if (!Utils.isNoB(this.phoneNo)) {
                this.getRealSatffInfoByPhoneNo(this.phoneNo);
            }
            if (!Utils.isNoB(this.id)) {
                this.getServicerXStaff();
            }
        },
        methods: {
            getRealSatffInfoByPhoneNo(phoneNo) {
                let self = this;
                realAuthxApi.getRealSatffInfoByPhoneNo({
                    phoneNo: phoneNo
                }, function (result) {
                    if (result.type == "info") {
                        let realStaff = result.data;
                        if (!Utils.isNoB(realStaff) && realStaff.jointId != null) {
                            self.noDisabled = true;
                        }
                    }
                });
            },
            getServicerXStaff: function () {
                let self = this;
                servicerApi.getServicerXstaff({
                    id: self.id
                }, function (result) {
                    if (result.type == "info") {
                        let staffInfo = result.data;
                        self.staffInfo = Utils.merge({}, staffInfo);
                    }
                });
            },
            onBeforeUpload: function (fileItems, uploader) {
                if (fileItems.length === 0) {
                    this.$message.error('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            onUploadDone: function (result) {
                let self = this;
                if (result.type === 'info') {
                    let files = result.data.files;
                    self.staffInfo.headUuid = files[0].fileUuid;
                    self.staffInfo.fileBrowseUrl = files[0].fileBrowseUrl;
                    self.staffInfo = Utils.merge({}, self.staffInfo);
                } else {
                    this.$message.success(result.message);
                }
            },
            removeUpload: function () {
                let self = this;
                self.staffInfo.headUuid = null;
                self.staffInfo.fileBrowseUrl = null;
                self.staffInfo = Utils.merge({}, self.staffInfo);
            },
            getDlgResult: function () {
                let result = {};
                result.type = "info";
                //
                let staffInfo = this.staffInfo;
                // 如果[用户手机]为台湾手机号，联系邮箱不可为空。
                if (!Utils.isNoB(staffInfo.phoneNo) && /^[0][9][0-9]{8}$/.test(staffInfo.phoneNo) && Utils.isNoB(staffInfo.contactEmail)) {
                    //
                    result.type = "warn";
                    result.message = "台湾号码-[联系邮箱]不可为空！";
                    return result;
                }
                this.$refs['staffInfo'].validate(function (valid) {
                    if (valid) {
                        //
                        result.data = staffInfo;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/orgStruct/ServicerXStaffSave.vue